export default __webpack_public_path__ + "static/media/beauty_2020_OV_seemore_EH-HS99_2_201029.5c8cc2a4.jpg";